var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPdf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4813 1.66669H3.51836C2.49984 1.66669 1.6665 2.50002 1.6665 3.51854V16.4815C1.6665 17.5 2.49984 18.3334 3.51836 18.3334H16.4813C17.4998 18.3334 18.3332 17.5 18.3332 16.4815V3.51854C18.3332 2.50002 17.4998 1.66669 16.4813 1.66669ZM7.68502 9.53706C7.68502 10.2778 7.03687 10.9259 6.29613 10.9259H5.37021V12.7778H3.98132V7.22224H6.29613C7.03687 7.22224 7.68502 7.87039 7.68502 8.61113V9.53706ZM12.3147 11.3889C12.3147 12.1297 11.6665 12.7778 10.9258 12.7778H8.61095V7.22224H10.9258C11.6665 7.22224 12.3147 7.87039 12.3147 8.61113V11.3889ZM16.0184 8.61113H14.6295V9.53706H16.0184V10.9259H14.6295V12.7778H13.2406V7.22224H16.0184V8.61113ZM9.99984 8.61113H10.9258V11.3889H9.99984V8.61113ZM5.37021 8.61113H6.29613V9.53706H5.37021V8.61113Z",
    fill: "#E92A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pdf.9e6ae09f.svg";
export { ForwardRef as ReactComponent };